// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EmVxx","comment":"styles_comment__1lRsp"};